module.exports = __webpack_public_path__ + "static/media/vscode.e60fcd09.svg";